import p1_img from './product_1.png'
import p2_img from './product_2.png'
import p3_img from './product_3.png'
import p4_img from './product_4.png'

let data_product = [
  {
    id: 1,
    name: "Tenet",
    year: "2020",
    category: "streaming",
    genre: "Action, Sci-Fi, Thriller",
    image: p1_img,
    streaming_price: 4.99,
    streaming_old_price: 9.99,
  },
  {
    id: 2,
    name: "Wonder Woman 1984",
    year: "2020",
    category: "streaming",
    genre: "Action, Adventure, Fantasy",
    image: p2_img,
    streaming_price: 3.99,
    streaming_old_price: 8.99,
  },
  {
    id: 3,
    name: "Soul",
    year: "2020",
    category: "streaming",
    genre: "Animation, Adventure, Comedy",
    image: p3_img,
    streaming_price: 3.49,
    streaming_old_price: 8.49,
  },
  {
    id: 4,
    name: "Nomadland",
    year: "2020",
    category: "streaming",
    genre: "Drama",
    image: p4_img,
    streaming_price: 4.99,    
    streaming_old_price: 9.99,
  },
];

export default data_product;